const INITIAL_STATE = {
    searchKey: null,
    loading: false,
    loaded: false,
    error:null,
    customerBranches: null,
    selectedCustomerBranches: []
};

export default function(state = INITIAL_STATE, action) {

    switch(action.type) {
        case "UPDATE_SEARCH_KEY":
            return {...state, searchKey: action.payload };
        case "FIND_CUSTOMER_BRANCHES":
            return {...state, loading: true, loaded: false };
        case "FIND_CUSTOMER_BRANCHES_SUCCESS":
            return {...state, customerBranches: action.payload, loading: false, loaded: true};
        case "ADD_CUSTOMER_BRANCH":
            return {...state, selectedCustomerBranches: [...state.selectedCustomerBranches, action.payload]};

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/branchSelector.js